<div class="cads-checkbox-group" [class.cads-checkbox-group--error]="_hasError()">
  @if (config().label) {
    <span [id]="_groupLabelId()" class="cads-checkbox-group__label" [class.cads-checkbox-group__label--error]="_hasError()">
      {{ config().label }}
      @if (config().required) {
        <span class="cads-checkbox-group__required" aria-hidden="true">*</span>
      }
    </span>
  }
  <div class="cads-checkbox-group__rows">
    @for (option of config().options; track option.id) {
      <label
        class="cads-checkbox-group__option"
        [class.cads-checkbox-group__option--selected]="_isChecked(option)"
        [class.cads-checkbox-group__option--disabled]="_isDisabled(option)"
        [class.cads-checkbox-group__option--bare]="!_cardStyle(option)"
        [class.cads-checkbox-group__option--error]="_hasError()"
        [attr.for]="_rowInputId(option)"
      >
        <input
          class="cads-checkbox-group__input"
          type="checkbox"
          [id]="_rowInputId(option)"
          [checked]="_isChecked(option)"
          [disabled]="_isDisabled(option)"
          [attr.aria-label]="_rowAriaLabel(option) || null"
          (change)="_onRowChange(option, $event)"
        />
        <span class="cads-checkbox-group__indicator" aria-hidden="true">
          <span class="cads-checkbox-group__checkbox" [class.cads-checkbox-group__checkbox--checked]="_isChecked(option)">
            @if (_isChecked(option)) {
              <svg class="cads-checkbox-group__check-svg" viewBox="0 0 12 12" focusable="false" aria-hidden="true">
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M2 6l3 3 5-6"
                />
              </svg>
            }
          </span>
        </span>
        <span class="cads-checkbox-group__body">
          @if (_heading(option); as h) {
            <cads-heading-detail-bit [config]="h" />
          } @else {
            @if (_subtitleOnly(option); as sub) {
              <span class="cads-checkbox-group__subtitle-only">{{ sub }}</span>
            } @else {
              <span class="cads-checkbox-group__row-label">{{ option.label ?? '' }}</span>
            }
          }
        </span>
      </label>
    }
  </div>
  @if (_showCaption()) {
    <p
      [id]="_captionId()"
      class="cads-checkbox-group__caption"
      [class.cads-checkbox-group__caption--error]="_hasError()"
      [attr.role]="_hasError() ? 'alert' : null"
    >
      {{ _captionText() }}
    </p>
  }
</div>
